import { IconButton } from '@synoptic/ui-kit/button/icon-button.tsx';
import { ArrowLeftIcon } from '@synoptic/ui-kit/icons/react/arrow-left.tsx';
import { FC } from 'react';
import { headerBack } from '@/components/page-header/back-button.css.ts';
import { useNavigateBack } from '@/components/page-header/use-navigate-back.ts';

export const BackButton: FC<{ fallbackReturnTo?: string }> = ({
  fallbackReturnTo,
}) => {
  const navigateBack = useNavigateBack(fallbackReturnTo);

  return (
    <IconButton
      className={headerBack}
      onClick={navigateBack}
      variant="ghost"
      size="small"
    >
      <ArrowLeftIcon style={{ width: 24, height: 24 }} />
    </IconButton>
  );
};
